import React, {useEffect} from "react";
import {ClickAwayListener, Slider, TextField} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import i18n from "../../../i18nextInitiator";
import {connect} from "react-redux";
import {changeAreaValue} from "../../../actions/actionCreators";

const t = i18n.getFixedT('fa','general');

const mapStateToProps = state => ({ ...state });

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    input: {
        "& input": {
            textAlign: "center",
        }
    }
});

const AreaSelector = (props) => {

    const {
        order: {
            order: {
                metraj: value
            } = {}
        } = {}
    } = props
    const classes = useStyles();

    const [areaAmounts] = React.useState({min: 30, max: 200})
    const [tooltip, setTooltip] = React.useState(false);
    const [amount, setAmount] = React.useState(t("more"));

    useEffect(()=>{
        if (value === areaAmounts.min || value === areaAmounts.max ){
            setTooltip(true)
            if (value === areaAmounts.min)
                setAmount(t("less"))
            else
                setAmount(t("more"))
        }
    }, [value])
    const handleSliderChange = (event, newValue) => {
        changeAreaValue(newValue);
    };

    return <div className={classes.root}>
        <Typography>
            {t('area-selector.title')}
        </Typography>
        <Typography variant={"subtitle2"}>
            {t('area-selector.subtitle')}
        </Typography>
        <Grid container spacing={2} alignItems="center">

            <Grid item xs>
                <PrettoSlider
                    value={value}
                    onChange={handleSliderChange}
                    max={areaAmounts.max}
                    min={areaAmounts.min}
                />
            </Grid>

            <Grid item>
                <ClickAwayListener onClickAway={()=>setTooltip(false)}>
                    <Tooltip placement={"top-end"} open={tooltip} title={t('area-selector.tooltip', {amount} )} arrow>
                        <TextField
                            class={classes.input}
                            value={value}
                            onChange={changeAreaValue}
                            inputProps={{
                                min: areaAmounts.min,
                                max: areaAmounts.max,
                                type: 'number',
                            }}
                        />
                    </Tooltip>
                </ClickAwayListener>
            </Grid>
        </Grid>
    </div>
}

const PrettoSlider = withStyles({
    root: {
        height: 8,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
})(Slider);

export default connect(mapStateToProps)(AreaSelector);